import React, { useState, useEffect } from "react";
import close from "../imgs/icons/close.svg";
import Select from 'react-select';
import pianiNode from "node/piani/piani";
import delet from '../imgs/icons/delete.svg';
import modifica from '../imgs/icons/modifica.svg';
import confirmW from '../imgs/icons/confirmW.svg';
import magazzinoNode from "node/magazzino/magazzino";

import lang from "../lang.json";

const langSet = lang[localStorage.getItem("lang")].scheda_stanza;
const sort = "id";
const order = "asc";

const SchedaSensoriOperatore = (props) => {
    const [mod, setMod] = useState(0);
    const [status, setStatus] = useState(0);
    // console.log(props.pianoId)
    const [sensori, setSensori] = useState([]);
    const [sensoriSel, setSensoriSel] = useState([]);
    const [sensoriDel, setSensoriDel] = useState([]);
    const [sensoriMag, setSensoriMag] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);
    
    const accountData = JSON.parse(localStorage.getItem('account'));

    const [selectedOption, setSelectedOption] = useState(null);
    
    useEffect(() => {
      if (sensori.length === 0) {
        setFilteredOptions(
          sensoriMag.map(
            (sensoremag) => ({
            value: sensoremag.id,
            label: `${sensoremag.nome} - ${sensoremag.tipo}`,
            })
          )
        );
      } else {
        setFilteredOptions([]);
      }
    }, [sensori]);

    const defSelettore = "selettore selettoreFlex selettoreMiddle selettoreBorder";
    const selSelettore = "selettore selettoreFlex selettoreMiddle selettorePurple selettoreShadow";
    const defContinua = "selettore selettoreFlex selettoreBlue";

    async function salvaModifiche() {
        try {
            if (sensoriDel.length > 0) {
                for (let i = 0; i < sensoriDel.length; i++) {
                    await pianiNode.removeSensoreOperatoreinPiano(accountData.token, props.pianoId, sensoriDel[i].id);
                }
            }
            if (sensoriSel.length > 0) {
                for (let i = 0; i < sensoriSel.length; i++) {
                    await pianiNode.putSensoreOperatoreinPiano(accountData.token, props.pianoId, sensoriSel[i].id);
                }
            }
            setSensoriSel([]);
            setSensoriDel([]);
            setMod(0);
            props.loading(false);
        } catch (e) {
            console.log(e);
        }                
    }

    function Sens(azione, id) {
        if (azione === 'add') {
            setSensoriSel([sensoriMag.filter((item) => item.id === id)[0]]);
            setSensori([sensoriMag.filter((item) => item.id === id)[0]]);
        } else if (azione === 'del') {
            setSensoriDel([sensori.filter((item) => item.id === id)[0]]);
            let index;
            index = sensori.findIndex((x) => x.id === id);
            sensori.splice(index, 1);
            setSensori([...sensori]);
        }
    }

    async function getSensori() {
        props.loading(true);
        //prendi tutti i sensori dal magazzino struttura 
        await magazzinoNode.getMagazzinoStruttura(accountData.token, sort, order).then((res) => {
            if(!res.result) throw res.error;
            const bloccoTipi = ["AA", "Pulsante"];
            setSensoriMag(
              (res.data ?? []).filter(sensor =>
                bloccoTipi.includes(sensor.tipo)
              )
            );
        }).catch((e) => console.log(e.toString)).finally(() => props.loading(false));
    }

    async function getSensoriOperatore() {
        props.loading(true);
        await pianiNode.getSensoriOperatore(accountData.token, props.pianoId).then((res) => {
            if(!res.result) throw res.error;
            setSensori(res.data);
        }).catch((e) => console.log(e.toString)).finally(() => props.loading(false));
    }

    useEffect(() => {
        getSensori()
        getSensoriOperatore()
        setMod(0);
        setStatus(0);
    }, [props]);

    return (
        <>
            <div id="Header" className="headerPopup" style={{ justifyContent: "start", overflowY: "auto" }}>
                <div className={status === 0 ? selSelettore : defSelettore}   onClick={() => setStatus(0)} >
                    <p>{"Sensori"}</p>
                </div>
            </div>
            <div id="PopupBody">
                <div style={{ display: status === 0 ? "" : "none" }}>
                    <table id="TitoliLista" >
                        <tbody>
                            <tr>
                                <td width="15%" style={{ border: 0 }}>{langSet.nome} </td>
                                <td width="15%" style={{ border: 0 }}>ID </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.tipo} </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.stato} </td>
                                <td width="15%" style={{ border: 0 }}>{langSet.batteria} </td>
                                <td width="25%" style={{ border: 0 }}></td>
                            </tr>
                        </tbody>
                    </table>
                     <Select id="Select" isDisabled={mod === 0 ? true : false}
                        styles={{
                            control: (provided) => ({ ...provided, width: '300px', fontSize: "90%", color: "#2B318A", fontWeight: "600", borderRadius: "20px", 
                                                    overflowX: "hidden", boxShadow: "none", "&:hover": { borderRadius: "25px", boxShadow: "none", width:"300px" } }),
                            input: (provided) => ({ ...provided, color: "#2B318A", fontWeight: "600", fontSize: "90%", textAlign:"center", marginLeft:"10px" }),
                            menu: (provided) => ({ ...provided, width: '300px', fontSize: "90%", color: "#2B318A", fontWeight: "600", borderRadius: "20px", 
                                                    boxShadow: "none",  border: "solid 1px #2B318A", overflowX: "hidden", 
                                                    "&:hover": { borderRadius: "25px", boxShadow: "none", width:"300px" } }),
                            option: (provided) => ({ ...provided, color: "#2B318A", fontWeight: "600", fontSize: "90%", textAlign:"center", marginLeft:"10px", 
                                                    overflowY: "scroll", maxHeight: "25em", overflowX: "hidden"}),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                          }}
                        menuPortalTarget={document.body}
                        options={filteredOptions}
                        value={selectedOption}
                        onChange={(selected) => {setSelectedOption(selected); Sens("add", selected.value)}}
                        placeholder={langSet.selezionaSensore}
                        isSearchable
                        /><i style={{ fontSize: "90%", color: "#d3d3d3", display: mod === 1 ? "" : "none" }}>* {langSet.massimo1PerTipologia}</i>
                    <div style={{ overflow: "scroll", maxHeight: "25em" }}>
                        {sensori.length > 0 ?
                            sensori.map((sensore, i) => (
                                <table id="Lista" key={i}>
                                    <tbody>
                                        <tr key={sensore}>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.nome}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.id_sensore ?? sensore.id}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.tipo}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.stato}</td>
                                            <td width="15%" style={{ padding: 0, paddingLeft: ".5em" }}>{sensore.batteria}</td>
                                            <td width="25%" style={{ padding: 0, paddingLeft: ".5em" }}>
                                                {mod === 0 ? null :
                                                    <div className="selettore selettoreFlex selettoreViolet" onClick={() => Sens("del", sensore.id)}>
                                                        <p>{langSet.disassocia}</p>
                                                        <img src={delet} alt="delete" />
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )) : <p style={{ textAlign: "center", margin: "1em", display: "" }}>{langSet.nessunSensore}</p>
                        }
                    </div>
                    <div className="navigators">
                        {mod === 0 ?
                            <div
                                className="selettore selettoreFlex selettoreViolet"
                                onClick={() => setMod(1)}
                                style={{ display: accountData.tipo === 4 ? "none" : null }}
                            >
                                <p>{langSet.modifica}</p>
                                <img src={modifica} alt='modifica' style={{ width: "1em" }} />
                            </div>
                            : <>
                                <div
                                    className={defContinua}
                                    onClick={() => salvaModifiche()}
                                >
                                    <p>{langSet.salva}</p>
                                    <img src={confirmW} alt='confirmW' style={{ width: "0.8rem", marginLeft: "4px"}} />
                                </div>
                                <div className="selettore selettoreFlex selettoreViolet" onClick={() => { setMod(0); getSensoriOperatore() }}>
                                    <p>{langSet.annulla}</p>
                                    <img className="icon-popup" src={close} alt="close" />
                                </div>
                            </>
                        }
                    </div>
                </div>
              
            </div>

        </>
    );
}

export default SchedaSensoriOperatore;